import React, { ReactNode } from 'react';
import { PaperProps } from '@mui/material';
import cn from 'classnames';
import Dialog from '@mui/material/Dialog';
import { createSx } from '../../utils';

const sx = createSx({
  paper: ({ breakpoints }) => ({
    overflowY: 'auto',
    '&.allowOverflow': {
      overflowY: 'unset'
    },
    '&.error': {
      border: theme => `1px solid ${theme.palette.error.outline}`
    },
    '&.success': {
      border: theme => `1px solid ${theme.palette.success.outline}`
    },
    '&.warning': {
      border: theme => `1px solid ${theme.palette.warning.outline}`
    },
    '&.info': {
      border: theme => `1px solid ${theme.palette.neutral.outlineVariant}`
    },
    [breakpoints.down('md')]: {
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      borderRadius: 0,
      margin: 0,
    },
  }),
});

interface ModalProps {
  open: boolean;
  children: ReactNode;
  onClose: () => void;
  testID?: string;
  modalType?: string;
  disableRestoreFocus?: boolean;
  allowOverflow?: boolean;
}

const ModalWindow = ({
  open,
  children,
  onClose,
  testID,
  modalType = 'info',
  disableRestoreFocus = false,
  allowOverflow = false
}: ModalProps) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          'data-test-id': (testID || 'modal-window'),
          sx: sx.paper,
          className: cn(modalType, { allowOverflow })
        } as PaperProps
      }}
      maxWidth='xl'
      disableRestoreFocus={disableRestoreFocus}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {children}
    </Dialog>
  );
};

export default ModalWindow;
